"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disabledMixin = void 0;
var _disabledCursorMixin = require("./disabledCursorMixin");
var _disabledOpacityMixin = require("./disabledOpacityMixin");
/** @mixin disabledMixin */
/**
 * Adds disabled opacity and cursor styling to a component.
 *
 * @example
 * import { disabledMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${disabledMixin}
 * `;
 *
 * <Component>My component with regular styling</Component>
 * <Component disabled>My component with disabled styling</Component>
 *
 * @method
 * @param props {object}
 * @param {boolean} [props.disabled=false] - Renders the disabled styling.
 * @return {CSSObject}
 */
var disabledMixin = function disabledMixin(props) {
  return [(0, _disabledCursorMixin.disabledCursorMixin)(props), (0, _disabledOpacityMixin.disabledOpacityMixin)(props)];
};
exports.disabledMixin = disabledMixin;